import AppBar from '@material-ui/core/AppBar';
import HeaderHelp from './header/HeaderHelp';
import HeaderHikes from './header/HeaderHikes';
import HeaderLogin from './header/HeaderLogin';
import HeaderMap from './header/HeaderMap';
import HeaderMembership from './header/HeaderMembership';
import HeaderNotifications from './header/HeaderNotifications';
import HeaderSignup from './header/HeaderSignup';
import HeaderUser from './header/HeaderUser';
import Menu from '@material-ui/core/Menu';
import MenuIcon from '@material-ui/icons/Menu';
import React from 'react';
import theme from '../theme';
import Toolbar from '@material-ui/core/Toolbar';
import Divider from '@material-ui/core/Divider';
import withWidth from '@material-ui/core/withWidth';
import { SPRING_2 } from '../colors';

const linkStyle = {
    outline: 0,
    border: 0,
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
    display: 'flex',
    borderBottomColor: SPRING_2,
    borderBottomStyle: 'solid',
    alignItems: 'center'
};

const buttonStyle = {
    marginLeft: 2 * theme.spacing.unit,
    fontSize: 14,
    outline: 0
};


class Header extends React.Component {

    constructor(props) {
        super(props);

        this.hamburgerRef = React.createRef();
        this.state = {hamburgerOpen: false};
    }

    render() {
        const {staticURL} = this.props;

        return (<AppBar
            elevation={0}
            color="default"
            position="static"
        >
            <Toolbar>
                <a href="/" style={{
                    background: `url(${staticURL}img/logos_icons/gaia_gps_logo.svg) left center no-repeat`,
                    width: 200,
                    height: 41,
                    backgroundSize: '200px 41px',
                    marginRight: 18,
                    marginLeft: 0,
                    marginBottom: 0,
                }} />

                <div style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'stretch',
                    alignSelf: 'stretch',
                }}>
                    {this.renderLeftButtons()}
                </div>

                {this.renderAppIcons()}
                {this.renderRightButtons()}
                {this.renderHamburgerButton()}
                {this.renderHamburgerMenu()}
            </Toolbar>
        </AppBar>);
    }

    renderAppIcons() {
        const {isAuthenticated, hasMobileApp} = this.props.user;
        const {width, staticURL} = this.props;
        const style = {...buttonStyle, height: 34, verticalAlign: 'middle'};

        if (!isAuthenticated || hasMobileApp || width === 'xs') return null;

        return (<React.Fragment>
            <a href={`https://itunes.apple.com/us/app/gaia-gps/id1201979492?mt=8&uo=4`} target="itunes_store">
                <img
                    style={style}
                    src={`${staticURL}img/appstore.svg`}
                    alt="Download on the App Store"
                />
            </a>

            <a href="https://market.android.com/details?id=com.trailbehind.android.gaiagps.pro&hl=en" target="_blank">
                <img
                    style={style}
                    src={`${staticURL}img/icons/play_badge.png`}
                    alt="Get it on Google Play"
                />
            </a>
        </React.Fragment>);
    }

    renderLeftButtons() {
        if (this.isHamburgerVisible()) return null;
        const {user} = this.props;

        return (<React.Fragment>
            <HeaderMap.Toolbar style={linkStyle} />
            <HeaderHikes.Toolbar style={linkStyle} user={user} />
            <HeaderHelp.Toolbar style={linkStyle} user={user} />
            <HeaderMembership.Toolbar style={linkStyle} user={user} />
        </React.Fragment>);
    }

    renderRightButtons() {
        if (this.isHamburgerVisible()) return null;
        const {user, nextFromRegister} = this.props;

        return (<React.Fragment>
            <HeaderLogin.Toolbar style={buttonStyle} user={user} />
            <HeaderSignup.Toolbar nextFromRegister={nextFromRegister} style={buttonStyle} user={user} />
            <HeaderNotifications.Toolbar style={linkStyle} user={user} />
            <HeaderUser.Toolbar style={linkStyle} user={user} />
        </React.Fragment>);
    }

    renderHamburgerButton() {
        if (!this.isHamburgerVisible()) return null;

        return (<a
            style={linkStyle}
            ref={this.hamburgerRef}
            href='#'
            onClick={event => {
                event.preventDefault();
                this.setState({hamburgerOpen: true});
            }}
        ><MenuIcon /></a>);
    }

    renderHamburgerMenu() {
        if (!this.isHamburgerVisible()) return null;
        const {user, nextFromRegister} = this.props;

        return (<Menu
            anchorEl={this.hamburgerRef.current}
            open={this.state.hamburgerOpen}
            onClose={() => this.setState({hamburgerOpen: false})}
        >
            <HeaderMap.HamburgerMenu />
            <HeaderHikes.HamburgerMenu user={user} />
            <Divider />
            <HeaderHelp.HamburgerMenu user={user} />
            <HeaderMembership.HamburgerMenu user={user} />
            <Divider />
            <HeaderLogin.HamburgerMenu user={user} />
            <HeaderSignup.HamburgerMenu nextFromRegister={nextFromRegister} user={user} />
            <HeaderNotifications.HamburgerMenu user={user} />
            <HeaderUser.HamburgerMenu user={user} />

        </Menu>);
    }

    isHamburgerVisible() {
        return this.props.width === 'sm' || this.props.width === 'xs';
    }
}

export default withWidth()(Header);
